export default "__VITE_ASSET__YNlp13vF__"